import React, { useRef, useState, useCallback, useEffect } from 'react'
import ExtendedMdxRender from '../components/extendedMdxRender'
import Container from '../components/container'

import '../styles/short-talks.css'

export default function ShortTalks({ allTalks }) {
  const wrapRef = useRef(null)
  const [activeIdx, setActiveIdx] = useState(0)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    const wrap = wrapRef.current
    if (!wrap) return
    const cards = wrap.querySelectorAll('.short-talks__item')
    setTotal(cards.length)
  }, [])

  const scroll = useCallback((dir) => {
    const wrap = wrapRef.current
    if (!wrap) return
    const scroller = wrap.querySelector('.mdx-wrapper')
    if (!scroller) return
    const cards = scroller.querySelectorAll('.short-talks__item')
    if (!cards.length) return

    const nextIdx = Math.max(0, Math.min(cards.length - 1, activeIdx + dir))
    cards[nextIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    setActiveIdx(nextIdx)
  }, [activeIdx])

  const mdx = allTalks.edges[0].node

  let body = mdx.body
  const spliter = 'mdx("h3"'

  const bodyArray = body.split(spliter)

  const allStart = bodyArray[0].split(`mdx("h2",`)[0]
  const bodyAryFiltered = bodyArray.filter((item, index) => index > 0 && index < 10)

  const divWrap = `mdx("div",{className:"short-talks__item"},mdx("h3"`

  body = allStart + divWrap + bodyAryFiltered.join(`),${divWrap}`).replace(/,\s$/, '') + `))};\nMDXContent.isMDXComponent = true;`

  return (
    <Container
      ref={wrapRef}
      className="short-talks-wrap"
    >
      {activeIdx > 0 && (
        <button className="short-talks-nav short-talks-nav--prev" onClick={() => scroll(-1)} aria-label="上一个">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
        </button>
      )}
      <ExtendedMdxRender>{body}</ExtendedMdxRender>
      {activeIdx < total - 1 && (
        <button className="short-talks-nav short-talks-nav--next" onClick={() => scroll(1)} aria-label="下一个">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
        </button>
      )}
    </Container>
  )
}
/*
示例 dom
<div class="mdx-wrapper"><div class="short-talks__item"><h3 id="%F0%9F5%BC%8F" class="css-jf3wiu-H3Title e1rhpw2r2"><div class="css-r6aalo-Title"><a href="#%F0%9F5%BC%8F"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width=".8em" height=".8em"><path fill="currentColor" d=""></path></svg></a> 🚲 目前在探索的一个业务开发严格范式</div></h3><blockquote><div class="css-uz2xon ejg1i1m0">2026-02-20 13:23:00</div></blockquote><ol><li>领域与规范先行：依照领域模式而不是技术类型组织代码，高内聚低耦合，比如不区分组件pages、components、utils等大文件夹，转为业务驱动的页面文件夹和 shared 通用功能。</li><li>逻辑与视图分离：在组件中只调用 hooks 的逻辑封装，视图和状态严格分离；</li><li>测试和评审优先：在视图的实现之前，先对 hooks 进行测试和评审，可行之后再考虑视图的实现；</li></ol><div class="css-uz2xon ejg1i1m0">这几点目前还在探索中，不太符合快速实现的逻辑，但是感觉已经能明显提升代码质量了，尤其配合 AI 的能力。对于人来讲，先搭视图，然后做交互更符合直觉，但是代码质量方便后期需要不少的逻辑抽取和重构优化，但是 AI 去做逻辑层面的快搭，然后测试验证，然后再去做视图，这样反而能提升代码质量，也能提升整体的开发效率。</div></div></div>
*/